import { Box, Grid } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
	const {
		childIsRepeater,
		children,
		columnsScheme = [],
		gridColumnsCount,
		grow,
		gutter,
		align,
		justify,
		...boxProps
	} = props

	function RenderColumns() {
		const schemeLength = columnsScheme.length
		let row = 0

		if (Array.isArray(children) && !childIsRepeater) {
			return children.map((child, idx) => {
				if (Number.isInteger(idx / schemeLength)) row++
				const colIdx = idx + schemeLength - row * schemeLength
				const colProps = columnsScheme[colIdx] || {}

				return (
					<Grid.Col key={idx} {...colProps}>
						{child}
					</Grid.Col>
				)
			})
		}
		else if (Array.isArray(children) && childIsRepeater) {
			return children.slice(1).map((child, idx) => {
				if (Number.isInteger(idx / schemeLength)) row++
				const colIdx = idx + schemeLength - row * schemeLength
				const colProps = columnsScheme[colIdx] || {}

				return (
					<Grid.Col key={idx} {...colProps}>
						{child}
					</Grid.Col>
				)
			})
		}
		return <Grid.Col {...columnsScheme[0]}>{children}</Grid.Col>
	}
	return (
		<Box
			{...boxProps}
			{...boxProps.customProps}
		// стандартные пропсы. размеры, марджин и паддинг кастом пропс
		>
			<Grid
				// justify align параметры из документации
				grow={grow}
				bg='dark.5'
				overflow='hidden'
				gutter={gutter}
				align={align}
				justify={justify}
			>
				{RenderColumns()}
			</Grid>
		</Box>
	)
})

{/* <Grid.Col bg='red' span={4}>1</Grid.Col>
<Grid.Col bg='green' span={4}>2</Grid.Col>
<Grid.Col bg='blue' span={4}>3</Grid.Col> */}
